interface DateTime {
  date: Date[],
  hours: string,
  minutes: string,
  period: string
}

function weekdayLong (timestamp: number): string {
  return new Intl.DateTimeFormat('en-GB', {
    weekday: 'long'
  }).format(timestamp * 1000)
}

function timezone (length: 'long' | 'short'): string {
  const now = new Intl.DateTimeFormat('en-GB', {
    timeZoneName: length
  }).format(new Date())
  return now.substring(now.indexOf(' ') + 1)
}

function getUtcTimestamp (dateTime: DateTime): number {
  const { date, hours, minutes, period } = dateTime
  const dateObject = new Date(`${date[0].toDateString()} ${hours}:${minutes} ${period}`)
  const timestamp = dateObject.getTime()
  return (timestamp / 1000)
}

export default {
  weekdayLong: weekdayLong,
  timezone: timezone,
  getUtcTimestamp: getUtcTimestamp
}
